import amplitudeService from '@/services/amplitude'

const TrackingPlugin = {
  install: function(Vue: any): void {
    Vue.prototype.$tracking = amplitudeService
  },
}

export default TrackingPlugin
